// extracted by mini-css-extract-plugin
module.exports = {"root":"_1I6Ai","negative":"_37M9Z","slightlyNegative":"_3iart","slightlyPositive":"_30-UB","positive":"_2J-n8"};